import React from 'react';
import { motion, AnimatePresence, useReducedMotion } from 'framer-motion';
import { pageTransition, pageTransitionReduced } from '../../lib/motion';

// Wraps route content so pages fade/rise on navigation. Keyed by pathname for AnimatePresence.
const PageTransition = ({ routeKey, children }) => {
  const reduce = useReducedMotion();
  const variants = reduce ? pageTransitionReduced : pageTransition;
  return (
    <AnimatePresence mode="wait" initial={false}>
      <motion.div
        key={routeKey}
        variants={variants}
        initial="initial"
        animate="animate"
        exit="exit"
        style={{ willChange: 'opacity, transform', transformStyle: 'preserve-3d' }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
};

export default PageTransition;
